import { restApiDP } from "@plannel/services/utils/rest-api";

const getNpiHistory = params => {
  return restApiDP.get("/api/npi-history", {params});
};

const getAllForCSV = params => {
  return restApiDP.get("/api/npi-history/csv", {params});
}

const getNpiProfileAllForCSV = params => {
  return restApiDP.get("/api/npi-profile/csv", {params});
}

const getNpiProfile = params => {
  return restApiDP.get("/api/npi-profile", {params});
};

const getLifecycle = params => {
  return restApiDP.get("/api/lifecycle", {params});
};

const upsertNpiHistory = (data) => {
  return restApiDP.post("/api/npi-history/upsert", data);
}

const upsertNpiProfile = (data) => {
  return restApiDP.post("/api/npi-profile/upsert", data);
}

const upsertLifecycle = (data) => {
  return restApiDP.post("/api/lifecycle/upsert", data);
}

const getItemObjectByCodeOrName = (item) => {
  return restApiDP.get("/api/lifecycle/item", { params: { item } });
}

const getActualSalesByCustomerAndItem = (data) => {
  return restApiDP.post("/api/npi-history/customer-item", data);
};

const importAll = (formData) => {
  return restApiDP.post('/api/npi-profile/import-excel', formData);
};


const dpNpiHistoryService = {
  getNpiHistory,
  getAllForCSV,
  getNpiProfile,
  getNpiProfileAllForCSV,
  getLifecycle,
  upsertNpiHistory,
  upsertNpiProfile,
  upsertLifecycle,
  getItemObjectByCodeOrName,
  getActualSalesByCustomerAndItem,
  importAll
};

export default dpNpiHistoryService;